import { useDispatch, useSelector } from "react-redux";
import BackButton from "../../../../components/BackButton";
import { navigatedToPreviousStep } from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import { RootState } from "../../../../redux/store";
import { getEnumNameByNumber } from "../../../../util/enum";
import { BookingCreationERStep, BookingCreationP2PStep } from "../../../../redux/slice/bookingCreation/bookingCreationSlice";

const BookLocationNavigateBackAction = ({ onClickOverride }: { onClickOverride?: () => void }) => {
  const dispatch = useDispatch();
  const step = useSelector((state: RootState) => state.bookingCreation.step);
  // const locations = useSelector((state: RootState) => state.booking.locations);
  const useCase = useSelector((state: RootState) => state.bookingCreation.useCase);

  // Show back button on all steps except the very first step of the current flow
  const enumRef = useCase === "rental" || useCase === "sup" ? BookingCreationERStep : BookingCreationP2PStep;
  const stepName = getEnumNameByNumber(enumRef as any, step);
  const showBackButton = stepName !== "locationSelection" && step !== 0;

  const handleBackClick = () => {
    if (onClickOverride) return onClickOverride();
    dispatch(navigatedToPreviousStep());
  };

  return <BackButton hidden={!showBackButton} onClick={handleBackClick} />;
};

export default BookLocationNavigateBackAction;
